import { Component, OnInit, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../core/api.service';

@Component({
  selector: 'app-import-commit',
  imports: [RouterLink],
  template: `
    <section class="card">
      <h1>Import Reservations</h1>
      <p class="hint">The validated reservations are being imported into the staging table.</p>

      @if (message()) {
        <div class="msg" [class.err]="isError()">{{ message() }}</div>
      }

      <div class="actions">
        <a routerLink="/reservations" class="button">Go to Reservations</a>
      </div>
    </section>
  `,
  styles: `
    .card{max-width:760px;margin:0 auto;background:#fff;border:1px solid var(--line);border-radius:14px;padding:18px;display:grid;gap:14px}
    h1{margin:0}
    .hint{margin:0;color:var(--muted)}
    .actions{display:flex;gap:10px;flex-wrap:wrap}
    .button{height:40px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:10px;background:var(--primary);color:#fff;font-weight:700;padding:0 14px;text-decoration:none}
    .secondary{background:#6b778c}
    .msg{padding:10px 12px;border-radius:10px;background:#eef4ff;color:#0a2f6b;border:1px solid #c7d7f5}
    .msg.err{background:#fdecec;color:#8a1f1f;border-color:#f2c4c4}
  `,
})
export class ImportCommitComponent implements OnInit {
  private readonly api = inject(ApiService);
  private readonly router = inject(Router);

  readonly message = signal('Importing…');
  readonly isError = signal(false);

  async ngOnInit(): Promise<void> {
    try {
      const res = await firstValueFrom(this.api.post<{ ok: boolean; error?: string; result?: { inserted: number } }>('/import/commit', { wipeExisting: true }));
      if (!res.ok) {
        this.isError.set(true);
        this.message.set(res.error || 'Import failed.');
        return;
      }
      this.message.set(`Import complete. Inserted ${res.result?.inserted ?? 0} rows.`);
      window.dispatchEvent(new Event('settings-changed'));
    } catch {
      this.isError.set(true);
      this.message.set('Import failed.');
    }
  }
}
